import { collection, doc, getDoc, getDocs, query, updateDoc, where } from "firebase/firestore"
import { db } from "./config"

export async function getSubAdmins() {
    try {
        let usersRef = collection(db, 'users')
        let q = query(usersRef, where('role', '==', 'sub-admin'));

        // Execute the query
        const snapshot = await getDocs(q);
        const subAdmins = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        return subAdmins;
    } catch (e) {
        console.error("Error fetching sub-admins: ", e);
        throw e; // Rethrow the error for handling elsewhere if needed
    }
}

export async function addNewSubAdminByEmail(email, privileges) {
    try {
        const userQuery = query(collection(db, "users"), where("email", "==", email));
        const userSnapshot = await getDocs(userQuery);

        if (userSnapshot.empty) {
            console.error("User with the provided email does not exist");
            throw new Error("User with the provided email does not exist");
        }

        const userDoc = userSnapshot.docs[0];
        const role = userDoc.data().role;
        if(role === 'admin') {
            console.error("User is already an admin");
            throw new Error("Cannot set admin as sub-admin");
        }
        if(role === 'sub-admin') {
            console.error("User is already a sub-admin");
            throw new Error("User is already a sub-admin");
        }
        const userId = userDoc.id;
        await setAsSubAdmin(userId, privileges);
    } catch (error) {
        console.error("Error adding new sub-admin: ", error);
        throw error; // Rethrow the error for handling elsewhere if needed
    }
}

export async function setAsSubAdmin(userId, privileges) {
    try {
        console.log("Setting user as sub-admin with ID: ", userId, " and privileges: ", privileges)
        const userRef = doc(db, "users", userId)
        const userSnapshot = await getDoc(userRef)

        if (!userSnapshot.exists()) {
            console.error("User does not exist");
            throw new Error("User does not exist");
        }
        const userData = userSnapshot.data()
        if (userData.role === 'admin') {
            console.error("User is already an admin");
            throw new Error("Cannnot set admin as sub-admin");
        }
        await updateDoc(doc(db, "users", userId), {
            role: 'sub-admin',
            privileges: privileges
        });
        console.log("User profile created successfully");
    } catch (error) {
        console.error("Error creating user profile: ", error);
        throw error; // Rethrow the error for handling elsewhere if needed
    }
}

export async function removeSubAdmin(userId) {
    try {
        const userRef = doc(db, "users", userId)
        const userSnapshot = await getDoc(userRef)

        if (!userSnapshot.exists()) {
            console.error("User does not exist");
            throw new Error("User does not exist");
        }
        const userData = userSnapshot.data()
        if (userData.role !== 'sub-admin') {
            console.error("User is not a sub-admin");
            throw new Error("User is not a sub-admin");
        }
        await updateDoc(doc(db, "users", userId), {
            role: 'customer',
            privileges: []
        });
        console.log("Sub-admin removed successfully");
    } catch (error) {
        console.error("Error removing sub-admin: ", error);
        throw error; // Rethrow the error for handling elsewhere if needed  
    }
}
